<template>
  <div class="flex items-center">
    <trek-button
      tertiary
      icon-only
      icon="remove"
      class="mb-0 p-25"
      qaid="product-decrease-quantity"
      :disabled="disabled || !canDecrease"
      aria-label="Decrease quantity"
      @click.prevent="decrease"
    />
    <input
      id="product-quantity"
      v-model="inputValue"
      type="text"
      qaid="product-quantity"
      class="form-control bg-transparent border-none p-25 w-12 text-center"
      :disabled="disabled"
    />
    <trek-button
      tertiary
      icon-only
      icon="add"
      class="mb-0 p-25"
      qaid="product-increase-quantity"
      :disabled="disabled || !canIncrease"
      aria-label="Increase quantity"
      @click.prevent="increase"
    />
  </div>
</template>
<script>
import TrekButton from '@/components/TrekButton';

export default {
  name: 'QuantityInput',
  components: {TrekButton},
  props: {
    value: {
      type: Number,
      default: 1,
    },
    maximum: {
      type: Number,
      default: 9999,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: 1,
    };
  },
  computed: {
    canDecrease() {
      return this.inputValue > 1;
    },
    canIncrease() {
      return this.maximum < 1 || this.inputValue < this.maximum;
    },
  },
  watch: {
    value(value) {
      this.inputValue = value;
    },
    inputValue(value, oldValue) {
      value = parseInt(value);

      if (!value || value < 1) {
        value = 1;
      } else if (this.maximum > 0 && value > this.maximum) {
        value = this.maximum;
      }

      if (value !== oldValue) {
        this.$emit('input', value);
      }

      this.inputValue = value;
    },
  },
  created() {
    this.inputValue = this.value;
  },
  methods: {
    decrease() {
      this.inputValue--;
    },
    increase() {
      this.inputValue++;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control[disabled] {
  background-color: transparent;
}
</style>
